import { render, staticRenderFns } from "./IdleTimer.vue?vue&type=template&id=345be290&"
import script from "./IdleTimer.vue?vue&type=script&lang=ts&"
export * from "./IdleTimer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports